import { Layout, Menu } from "antd";

import {
  DatabaseOutlined,
  DesktopOutlined,
  KeyOutlined,
  BarChartOutlined,
  StarOutlined,
  UserOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";

import "./styles.css";
import { useState } from "react";

const { Sider } = Layout;
const { SubMenu } = Menu;

const SideNav = ({ updateTab, userEmail }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);

  const masterDataEntries = [
    { key: "manage-crew", text: "Manage Speakers" },
    { key: "manage-genres", text: "Manage Categories" },
    { key: "manage-languages", text: "Manage Languages" },
  ];

  const featuredContentEntries = [
    { key: "banners", text: "Banners" },
    { key: "playlists", text: "Sections/Playlists" },
  ];

  const reportsTabEntries = [
    { key: "overview", text: "Overview" },
    { key: "web-analytics", text: "Website" },
    { key: "subscriber-report", text: "Subscribers" },
    { key: "content-views", text: "Content" },
    { key: "metrics", text: "Glossary" },
  ];

  return (
    <Sider
      key={"sider-nav"}
      width={255}
      theme="light"
      className="side-nav-wrapper"
      style={{ height: "100%" }}
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        selectedKeys={selectedKeys}
        onSelect={(info) => {
          console.log(info);
          setSelectedKeys(info.selectedKeys);
        }}
        style={{ borderRight: 0, width: "100%" }}
        className="menu-bar"
      >
        <Menu.Item
          key="dashboard"
          icon={<DesktopOutlined />}
          onClick={() => {
            setTimeout(() => {
              updateTab("dashboard");
              setSelectedKeys(["dashboard"]);
            }, 1);
          }}
        >
          Dashboard
        </Menu.Item>
        <Menu.Item
          key="marketting-content"
          icon={<VideoCameraAddOutlined />}
          onClick={() => {
            updateTab("loading");
            setTimeout(() => {
              updateTab("manage-marketting-content");
              setSelectedKeys(["manage-marketting-content"]);
            }, 10);
          }}
        >
          Manage Content
        </Menu.Item>
        <SubMenu
          key="master-data"
          title="Master Data"
          icon={<DatabaseOutlined />}
        >
          {masterDataEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                setTimeout(() => {
                  updateTab(entry.key);
                  setSelectedKeys([entry.key]);
                }, 10);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu
          key="featured-content"
          title="Featured Content"
          icon={<StarOutlined />}
        >
          {featuredContentEntries.map((entry) => (
            <Menu.Item
              key={entry.key}
              onClick={() => {
                updateTab("loading");
                setTimeout(() => {
                  updateTab(entry.key);
                  setSelectedKeys([entry.key]);
                }, 10);
              }}
            >
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <SubMenu key="reports" title="Analytics" icon={<BarChartOutlined />}>
          {reportsTabEntries.map((entry) => (
            <Menu.Item key={entry.key} onClick={() => updateTab(entry.key)}>
              {entry.text}
            </Menu.Item>
          ))}
        </SubMenu>
        <Menu.Item
          key="employees"
          icon={<UserOutlined />}
          onClick={() => {
            setTimeout(() => {
              updateTab("manage-employees");
              setSelectedKeys(["manage-employees"]);
            }, 1);
          }}
        >
          Manage Employees
        </Menu.Item>
        <Menu.Item
          key="permissions"
          icon={<KeyOutlined />}
          onClick={() => {
            setTimeout(() => {
              updateTab("manage-permissions");
              setSelectedKeys(["manage-permissions"]);
            }, 10);
          }}
        >
          Manage Permissions
        </Menu.Item>
        {/* <Menu.Item
          key="user"
          style={{
            position: "absolute",
            float: "bottom",
            // bottom: 0,
            zIndex: 0,
            color: "#fff",
            backgroundColor: "#666",
            margin: 0,
            marginTop: "2%",
          }}
        >
          {userEmail}
        </Menu.Item> */}
      </Menu>
      <Menu style={{ width: "100%" }}>
        <Menu.Item
          key="user"
          style={{
            position: "absolute",
            bottom: 0,
            zIndex: 0,
            color: "#fff",
            backgroundColor: "#666",
            margin: 0,
            marginTop: "2%",
          }}
        >
          {userEmail}
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default SideNav;
